import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import styles from '../../../../styles/icons/logos/molson-predictions-horizontal.module.scss';

import canadiansLogo from '../../../../img/nhl/molson-canadians.svg';
import predictionsLogo from '../../../../img/nhl/molson-predictions-horizontal.png';

const propTypes = {
    className: PropTypes.string,
};

const defaultProps = {
    className: null,
};

function MolsonPredictionsHorizontal({ className }) {
    return (
        <div
            className={classNames([
                styles.container,
                {
                    [className]: className !== null,
                },
            ])}
        >
            <img
                src={canadiansLogo}
                className={classNames([styles.logo, styles.molson])}
                alt="Molson Canadians"
            />
            <img
                src={predictionsLogo}
                className={classNames([styles.logo, styles.predictions])}
                alt="Molson Predictions"
            />
        </div>
    );
}

MolsonPredictionsHorizontal.propTypes = propTypes;
MolsonPredictionsHorizontal.defaultProps = defaultProps;

export default MolsonPredictionsHorizontal;
